import { __awaiter, __generator } from "tslib";
import { networkRequest } from '@tencent/ark-request';
import { CGI_OWNER_VIP_LEVEl } from './cgi-path';
var OwnerVipLevelRepo = /** @class */ (function () {
    function OwnerVipLevelRepo() {
    }
    /**
     * 获取文档 owner 的会员等级
     */
    OwnerVipLevelRepo.prototype.getOwnerVipLevel = function (fileId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, networkRequest.post(CGI_OWNER_VIP_LEVEl, {
                        file_id: fileId,
                    })];
            });
        });
    };
    return OwnerVipLevelRepo;
}());
export { OwnerVipLevelRepo };
